import { useState, useEffect } from 'react';
import CollapsibleForm from '../generic/CollapsibleForm';
import TagSelector from '../generic/TagSelector';
import { TAG_NO_THANKS } from '../constants/constants';

const GenericTagPreferences = ({
  dietaryPreferences,
  tags,
  customerTags,
  title,
  text,
  icon,
  testId,
  subheadTitle,
  subheadText,
}) => {
  const [formVisible, setFormVisibility] = useState(false);
  const [genericTagsText, setGenericTagsText] = useState('');
  const [initialPrefs, setInitialPrefs] = useState([]);
  const [currentPrefs, setCurrentPrefs] = useState([]);

  const currentPrefsMatchInitial =
    currentPrefs.length === initialPrefs?.length &&
    currentPrefs.every((pref) => initialPrefs.includes(pref));
  const tagsSet = new Set(tags.map((t) => t.id));
  const tagsUsedInSection = customerTags.filter((tag) => tagsSet.has(tag.id));
  let noTagsPreviously = false;

  const createTagsText = (tags) => {
    let noTags = tags.length === 0;
    let currentCustomerTagNumber = tagsUsedInSection.length;

    if (noTags) {
      if (currentCustomerTagNumber === 0 && !noTagsPreviously) {
        return;
      }
      if (currentCustomerTagNumber > 0 || noTagsPreviously) {
        setGenericTagsText('No thanks');
      }
    } else {
      setGenericTagsText(tags.map((t) => t.name).join(', '));
    }
  };

  const handleOnSelect = (tags, initialTags, currentTags) => {
    if (tags.length === 0 && !noTagsPreviously) noTagsPreviously = true;
    createTagsText(tags);
    if (!initialPrefs.length) setInitialPrefs(initialTags);
    setCurrentPrefs(currentTags);
  };

  useEffect(() => {
    const tagsSet = new Set(tags.map((t) => t.id));
    createTagsText(
      customerTags.filter((t) => {
        return t.preference > TAG_NO_THANKS && tagsSet.has(t.id);
      })
    );
  }, [customerTags]);

  return (
    <div data-testid={testId}>
      <CollapsibleForm
        title={title}
        text={genericTagsText ? genericTagsText : text}
        iconDesktop={icon}
        contentVisible={formVisible}
        toggleForm={() => setFormVisibility(!formVisible)}
        dataCy={testId}
      >
        <div className="protein-preferences">
          <div className="hr-mb-32_fixed hr-center-txt">
            <div className="hr-paragraph hr-mb-8">{subheadTitle}</div>
            <div className="hr-subtitle-md">{subheadText}</div>
          </div>
          <TagSelector
            tags={tags}
            customerTags={customerTags}
            onSelect={handleOnSelect}
            dietaryPreferences={dietaryPreferences}
          />
          <button
            data-testid="generic-preferences-update-button"
            className={'hr-btn-blue hr-max'}
            disabled={currentPrefsMatchInitial}
            onClick={() => {
              setFormVisibility(false);
            }}
          >
            Update
          </button>
        </div>
      </CollapsibleForm>
    </div>
  );
};

export default GenericTagPreferences;
